import SmartParking, { ParkingLot } from "../viewModels/SmartParking";
import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";


export function Add(model: SmartParking, accessToken: string) {
  const act = {
    type: Pre.SMART_PARKING + Actions.ADD,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}
export function Update(model: SmartParking, accessToken: string) {
  return {
    type: Pre.SMART_PARKING + Actions.UPDATE,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}
export function Remove(id: SmartParking, accessToken: string) {
  return {
    type: Pre.SMART_PARKING + Actions.REMOVE,
    payload: { id },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}
